import {useTheme} from '@mui/material/styles';
import React, {useContext, useEffect, useRef} from 'react';
import shadowClient from '../lib/clients/shadow/shadowClient';
import Logger from '../lib/Logger';
import Box from "../Common/Box";
import {AppManagerContext} from "../Common/Contexts";
import utils from "../lib/utils";
import {WiredScene} from "../lib/three/WiredScene";
import {Message} from "../lib/stores/MessageStore";
import {ClientEvent} from "../lib/clients/shadow/interfaces";

const logger = new Logger("ThreeScreenChat");

function ThreeScreen() {

    const theme = useTheme();
    const sceneRef = useRef<WiredScene>(null);
    const {renderers, setRenderers} = useContext(AppManagerContext);

    if (sceneRef.current) {
        sceneRef.current.syncTheme(theme);
    }

    useEffect(() => {

        const scene = new WiredScene({id: "fae"})
        scene.renderArea = renderAreaRef.current;
        scene.syncTheme(theme);
        sceneRef.current = scene;

        const onMessageCreate = utils.throttle(function onMessageCreate(message: Message) {
            scene.onMessage(message);
        }, 50);

        scene.run().then(() => {
            shadowClient.messageStore.on(ClientEvent.MESSAGE_CREATE, onMessageCreate);
            setRenderers([...renderers, scene.renderer])
        }).catch((error: any) => {
            logger.error(error);
        });

        return () => {
            scene.close();
            shadowClient.messageStore.removeListener(ClientEvent.MESSAGE_CREATE, onMessageCreate)
        }
    }, [])


    const renderAreaRef = useRef();
    return <Box
            forwardedRef={renderAreaRef}
            expand
            row
            color={"primary.dark"}
            bgcolor={"background.paper"}
    />

}

export default ThreeScreen;
